import { ConfigHelper } from './../../app/helpers/configHelper';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as aws from "aws-sdk";

@Injectable()
export class S3ServiceProvider {

  constructor(public http: HttpClient) {

  }

  get(caminhoDoObjeto){
    return new Promise((resolve, reject) => {
      var credentials = new aws.Credentials({
        accessKeyId: ConfigHelper.AWS_ACCESS_KEY_ID, secretAccessKey: ConfigHelper.AWS_SECRET_ACCESS_KEY
      });
  
      aws.config.update({
        region: ConfigHelper.AWS_DEFAULT_REGION,
        credentials: credentials
      });
  
      var s3 = new aws.S3({apiVersion: '2006-03-01'});
  
      var getParams = {
        Bucket: ConfigHelper.AWS_BUCKET, 
        Key: caminhoDoObjeto 
      }
  
      s3.getObject(getParams, (err, data)=>{
        if(err){
          reject(err);
        }else{
          resolve(data)
        }
      });

    });
  }

  upload(image, caminho, nomeArquivo) {
    return new Promise((resolve, reject) => {
      let key = caminho + nomeArquivo;
      var credentials = new aws.Credentials({
        accessKeyId: ConfigHelper.AWS_ACCESS_KEY_ID, secretAccessKey: ConfigHelper.AWS_SECRET_ACCESS_KEY
      });

      aws.config.update({
        region: ConfigHelper.AWS_DEFAULT_REGION,
        credentials: credentials
      });

      var s3 = new aws.S3({apiVersion: '2006-03-01'});

      var putParams = {
        Body: image, 
        Bucket: ConfigHelper.AWS_BUCKET, 
        Key: key
      }

      s3.putObject(putParams, function(err, data){
        if(err){
          reject(err)
        }else{
          resolve(data);
        }
      });
    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/s3-service/s3-service.ts